import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../store/rootReducer";
import { Dispatch } from "redux";

import { ZInput, ZButton } from "@zanichelli/albe-web-components/react";
import Heading from "../../components/Heading";
import Content from "../../components/Content";
import ContentCheekToCheek from "../../components/ContentCheekToCheek";

import {
  subscriptionEmailRequest,
  ISubscriptionEmailRequest,
  subscriptionEmailReset,
  ISubscriptionEmailReset,
} from "../../store/SubscriptionEmail/actions";

import { Utils } from "@zanichelli/myz-react-utils";

import { Wrap } from "./styles";

import i18next from "i18next";
import { withTranslation, WithTranslation } from "react-i18next";
import { ButtonVariant, InputStatus } from "@zanichelli/albe-web-components";
import ZLoader from "../../components/ZLoader";

const { isValidEmail } = Utils.Validators;

type Props = {
  myzTokenEmail?: string;
  error: null | Error;
  loading: boolean;
  subscriptionEmailRequest: (email: string) => ISubscriptionEmailRequest;
  subscriptionEmailReset: () => ISubscriptionEmailReset;
} & WithTranslation;

type State = {
  inputValue: string;
  enableSubmit: boolean;
  inputMessage?: string;
  inputStatus?: InputStatus;
};

class Home extends React.Component<Props, State> {
  public readonly state: State = {
    inputValue: "",
    enableSubmit: false,
    inputMessage: undefined,
    inputStatus: undefined,
  };

  componentDidMount() {
    this.props.subscriptionEmailReset();

    this.setInputValueFromMyzToken();
    this.enableSubmitButton();
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.myzTokenEmail !== prevProps.myzTokenEmail) {
      this.setInputValueFromMyzToken();
    }
    if (this.state.inputValue !== prevState.inputValue) {
      this.enableSubmitButton();
    }
  }

  setInputValueFromMyzToken() {
    if (!this.props.myzTokenEmail) return;
    this.setState({ inputValue: this.props.myzTokenEmail });
  }

  enableSubmitButton() {
    this.setState({ enableSubmit: isValidEmail(this.state.inputValue) });
  }

  handleStopTyping(value: string) {
    this.setState({ inputValue: value }, () => {
      const validEmail = !value || isValidEmail(value);
      this.setState({
        inputStatus: validEmail ? undefined : InputStatus.ERROR,
        inputMessage: validEmail
          ? undefined
          : i18next.t("newwotd.home.input.error"),
      });
    });
  }

  render() {
    const { inputValue, enableSubmit, inputStatus, inputMessage } = this.state;
    const { loading, subscriptionEmailRequest } = this.props;

    if (loading) return <ZLoader />;

    return (
      <ContentCheekToCheek>
        <Wrap>
          <Heading
            title={i18next.t("newwotd.title")}
            subtitle={i18next.t("newwotd.home.subtitle")}
          />

          <div className="description">
            <Content>{i18next.t("newwotd.home.description")}</Content>
          </div>

          <ZInput
            label={i18next.t("newwotd.home.input.label")}
            placeholder={i18next.t("newwotd.home.input.placeholder")}
            value={inputValue}
            status={inputStatus}
            message={inputMessage}
            onStopTyping={(e: CustomEvent) =>
              this.handleStopTyping(e.detail.value)
            }
            onKeyUp={(e: React.KeyboardEvent) => {
              if (!this.state.enableSubmit) return;
              Utils.Keyboard.handleEnter(
                e,
                subscriptionEmailRequest,
                inputValue,
              );
            }}
          />

          <ZButton
            variant={ButtonVariant.PRIMARY}
            disabled={!enableSubmit}
            onClick={() => subscriptionEmailRequest(inputValue)}
          >
            {i18next.t("newwotd.home.submitButton.label")}
          </ZButton>
        </Wrap>
        <div />
      </ContentCheekToCheek>
    );
  }
}

function mapStateToProps(state: GlobalState) {
  return {
    myzTokenEmail: state.myztokenuser.data?.loginId,
    error: state.subscriptionemail.error,
    loading: state.myztokenuser.loading || state.subscriptionemail.loading,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    subscriptionEmailRequest: (email: string) =>
      dispatch(subscriptionEmailRequest(email)),
    subscriptionEmailReset: () => dispatch(subscriptionEmailReset()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Home));
